import Medusa from '@medusajs/medusa-js'
import { LiveOrderBalanceService } from 'live/Order/LiveOrderBalanceService'

export const medusaClient = new Medusa({
  maxRetries: 3,
  baseUrl: process.env.NEXT_PUBLIC_MEDUSA_URL as string
})

export const medusaClientWithTwiceMoreRetries = new Medusa({
  maxRetries: 6,
  baseUrl: process.env.NEXT_PUBLIC_MEDUSA_URL as string
})

export const liveOrderBalanceService = new LiveOrderBalanceService()

export { liveFormFunnelConfigConditionService } from '@miles/domain/Dashboard/Service/FormFunnelConfig/FormFunnelConfigConditionService'
